// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubHeader-module__font-s-10___CEYi2 {
  font-size: 10px !important;
}

.SubHeader-module__font-s-12___zLveb {
  font-size: 12px !important;
}

.SubHeader-module__font-s-13___Y8tVo {
  font-size: 13px !important;
}

.SubHeader-module__font-s-14___Wt92S {
  font-size: 14px !important;
}

.SubHeader-module__font-s-15___JjG1T {
  font-size: 15px !important;
}

.SubHeader-module__font-s-16___fMVjU {
  font-size: 16px !important;
}

.SubHeader-module__font-s-18___OF1SU {
  font-size: 18px !important;
}

.SubHeader-module__font-s-20___alxvm {
  font-size: 20px !important;
}

.SubHeader-module__font-s-22___E3b2A {
  font-size: 22px !important;
}

.SubHeader-module__font-s-28___iam1e {
  font-size: 28px !important;
}

.SubHeader-module__font-w-400___MCCOw {
  font-weight: 400 !important;
}

.SubHeader-module__font-w-500___eAib7 {
  font-weight: 500 !important;
}

.SubHeader-module__font-w-600___oN5FV {
  font-weight: 600 !important;
}

.SubHeader-module__font-w-700___kMnsh {
  font-weight: 700 !important;
}

.SubHeader-module__p-5___VIXOa {
  padding: 5px !important;
}

.SubHeader-module__p-12___b_ghe {
  padding: 12px !important;
}

.SubHeader-module__p-16___lfMLF {
  padding: 16px !important;
}

.SubHeader-module__p-30___DOrAQ {
  padding: 30px !important;
}

.SubHeader-module__p-b-0___t7X1q {
  padding-bottom: 0 !important;
}

.SubHeader-module__p-b-5___y0aUa {
  padding-bottom: 5px !important;
}

.SubHeader-module__p-b-10___HAUBo {
  padding-bottom: 10px !important;
}

.SubHeader-module__p-b-12___z1a91 {
  padding-bottom: 12px !important;
}

.SubHeader-module__p-b-16___K20OL {
  padding-bottom: 16px !important;
}

.SubHeader-module__p-b-18___cTzSk {
  padding-bottom: 18px !important;
}

.SubHeader-module__p-b-20____MzR3 {
  padding-bottom: 20px !important;
}

.SubHeader-module__p-b-25____lMle {
  padding-bottom: 25px !important;
}

.SubHeader-module__p-b-30___QL_2i {
  padding-bottom: 30px !important;
}

.SubHeader-module__p-b-50___mY9D0 {
  padding-bottom: 50px !important;
}

.SubHeader-module__p-t-0___sbXtY {
  padding-top: 0 !important;
}

.SubHeader-module__p-t-12___sZOgE {
  padding-top: 12px !important;
}

.SubHeader-module__p-t-16___cTs1O {
  padding-top: 16px !important;
}

.SubHeader-module__p-t-18___YiXVu {
  padding-top: 18px !important;
}

.SubHeader-module__p-t-20___nZL_f {
  padding-top: 20px !important;
}

.SubHeader-module__p-t-30___KjI34 {
  padding-top: 30px !important;
}

.SubHeader-module__p-t-40___JZHv9 {
  padding-top: 40px !important;
}

.SubHeader-module__p-t-50___LUj7I {
  padding-top: 50px !important;
}

.SubHeader-module__p-l-20____aRKv {
  padding-left: 20px !important;
}

.SubHeader-module__p-l-30___nnbK7 {
  padding-left: 30px !important;
}

.SubHeader-module__p-l-40___btjXJ {
  padding-left: 40px !important;
}

.SubHeader-module__p-r-16___blGTr {
  padding-right: 16px !important;
}

.SubHeader-module__p-r-20___EI55r {
  padding-right: 20px !important;
}

.SubHeader-module__p-r-30___nlFVH {
  padding-right: 30px !important;
}

.SubHeader-module__p-r-50___VYTAU {
  padding-right: 50px !important;
}

.SubHeader-module__p-r-60___GsPJi {
  padding-right: 60px !important;
}

.SubHeader-module__m-b-1___SbmWw {
  margin-bottom: 1px !important;
}

.SubHeader-module__m-b-2___Lkwsr {
  margin-bottom: 2px !important;
}

.SubHeader-module__m-b-6___A4IwS {
  margin-bottom: 6px !important;
}

.SubHeader-module__m-b-8___qTEog {
  margin-bottom: 8px !important;
}

.SubHeader-module__m-b-10___fNT2h {
  margin-bottom: 10px !important;
}

.SubHeader-module__m-b-14___rQ7lU {
  margin-bottom: 14px !important;
}

.SubHeader-module__m-b-16___jyXFR {
  margin-bottom: 16px !important;
}

.SubHeader-module__m-b-20___SmZoR {
  margin-bottom: 20px !important;
}

.SubHeader-module__m-b-22____HLdV {
  margin-bottom: 22px !important;
}

.SubHeader-module__m-b-24___SbozO {
  margin-bottom: 24px !important;
}

.SubHeader-module__m-b-30___XsiGN {
  margin-bottom: 30px !important;
}

.SubHeader-module__m-b-32___ZDgeQ {
  margin-bottom: 32px !important;
}

.SubHeader-module__m-b-40___q7fkb {
  margin-bottom: 40px !important;
}

.SubHeader-module__m-t-2___cufqB {
  margin-top: 2px !important;
}

.SubHeader-module__m-t-3___Wm8jW {
  margin-top: 3px !important;
}

.SubHeader-module__m-t-4___aqdS6 {
  margin-top: 4px !important;
}

.SubHeader-module__m-t-5___TTTN6 {
  margin-top: 5px !important;
}

.SubHeader-module__m-t-8___nfRan {
  margin-top: 8px !important;
}

.SubHeader-module__m-t-10___Ali9_ {
  margin-top: 10px !important;
}

.SubHeader-module__m-t-15___U98G6 {
  margin-top: 15px !important;
}

.SubHeader-module__m-t-16___t3H9g {
  margin-top: 16px !important;
}

.SubHeader-module__m-t-20___zWRok {
  margin-top: 20px !important;
}

.SubHeader-module__m-t-22___mriH0 {
  margin-top: 22px !important;
}

.SubHeader-module__m-t-30___A71eM {
  margin-top: 30px !important;
}

.SubHeader-module__m-t-32___ofbwf {
  margin-top: 32px !important;
}

.SubHeader-module__m-l-auto___tIwmo {
  margin-left: auto !important;
}

.SubHeader-module__m-l-4___sj74t {
  margin-left: 4px !important;
}

.SubHeader-module__m-l-5___aDiDm {
  margin-left: 5px !important;
}

.SubHeader-module__m-l-6___C4DEB {
  margin-left: 6px !important;
}

.SubHeader-module__m-l-8___g3PVn {
  margin-left: 8px !important;
}

.SubHeader-module__m-l-10___kJtHW {
  margin-left: 10px !important;
}

.SubHeader-module__m-l-16___Rizi3 {
  margin-left: 16px !important;
}

.SubHeader-module__m-l-20___wLSHn {
  margin-left: 20px !important;
}

.SubHeader-module__m-l-24___WvgLr {
  margin-left: 24px !important;
}

.SubHeader-module__m-l-30___vsEpl {
  margin-left: 30px !important;
}

.SubHeader-module__m-l-35___N3G9w {
  margin-left: 35px !important;
}

.SubHeader-module__m-l-40___GU7bs {
  margin-left: 40px !important;
}

.SubHeader-module__m-r-8___xwzoS {
  margin-right: 8px !important;
}

.SubHeader-module__m-r-10___Qq4l4 {
  margin-right: 10px !important;
}

.SubHeader-module__m-r-16___BTZw8 {
  margin-right: 16px !important;
}

.SubHeader-module__m-r-20___uDdb3 {
  margin-right: 20px !important;
}

.SubHeader-module__m-r-24___JEEaV {
  margin-right: 24px !important;
}

.SubHeader-module__m-r-30___uKGZW {
  margin-right: 30px !important;
}

.SubHeader-module__m-r-40___ntpJp {
  margin-right: 40px !important;
}

.SubHeader-module__border-r-3___ldPMu {
  border-radius: 3px !important;
}

.SubHeader-module__border-r-4___onLbR {
  border-radius: 4px !important;
}

.SubHeader-module__border-r-6___RpHT_ {
  border-radius: 6px !important;
}

.SubHeader-module__border-r-10___dQs0Y {
  border-radius: 10px !important;
}

.SubHeader-module__border-r-12___yMbAk {
  border-radius: 12px !important;
}

.SubHeader-module__border-r-16___XjMQy {
  border-radius: 16px !important;
}

.SubHeader-module__border-r-50___EWE3B {
  border-radius: 50% !important;
}

.SubHeader-module__primary-border___lDvMx {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SubHeader-module__primary-border-b___IBVYP {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SubHeader-module__primary-border-t___wYKFz {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SubHeader-module__primary-border-l___YXGX5 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SubHeader-module__primary-border-r___D9ygY {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SubHeader-module__secondary-border___lsmz_ {
  border: 1px solid #637768;
}

.SubHeader-module__secondary-border-b___dk_aA {
  border-bottom: 1px solid #637768;
}

.SubHeader-module__secondary-border-t___h2nBd {
  border-top: 1px solid #637768;
}

.SubHeader-module__secondary-border-l___MhRKK {
  border-left: 1px solid #637768;
}

.SubHeader-module__secondary-border-r___SLnT6 {
  border-right: 1px solid #637768;
}

.SubHeader-module__gap-0___e6lgI {
  gap: 0 !important;
}

.SubHeader-module__gap-2___sM1MJ {
  gap: 2px !important;
}

.SubHeader-module__gap-4___WdgAH {
  gap: 4px !important;
}

.SubHeader-module__gap-5___LXXrs {
  gap: 5px !important;
}

.SubHeader-module__gap-6___ZbyGy {
  gap: 6px !important;
}

.SubHeader-module__gap-8___YGBqI {
  gap: 8px !important;
}

.SubHeader-module__gap-10___yAipQ {
  gap: 10px !important;
}

.SubHeader-module__gap-12___CcUia {
  gap: 12px !important;
}

.SubHeader-module__gap-14___CF1Ht {
  gap: 14px !important;
}

.SubHeader-module__gap-16___Zsp6l {
  gap: 16px !important;
}

.SubHeader-module__gap-18___Y47xj {
  gap: 18px !important;
}

.SubHeader-module__gap-20___ThRla {
  gap: 20px !important;
}

.SubHeader-module__gap-24___ebsL7 {
  gap: 24px !important;
}

.SubHeader-module__gap-26___RPEU9 {
  gap: 26px !important;
}

.SubHeader-module__gap-30___yuBkD {
  gap: 30px !important;
}

.SubHeader-module__gap-32___XjqzX {
  gap: 32px !important;
}

.SubHeader-module__gap-40____Bqho {
  gap: 40px !important;
}

.SubHeader-module__gap-50___L_dYk {
  gap: 50px !important;
}

.SubHeader-module__flex-1___tJtRt {
  flex: 1;
}

.SubHeader-module__flex-none___BRtXn {
  flex: none !important;
}

.SubHeader-module__flex-column___KS9VY {
  display: flex;
  flex-direction: column !important;
}

.SubHeader-module__flex-row___A9p7Y {
  display: flex;
  flex-direction: row !important;
}

.SubHeader-module__vertically-centered___zrvwW {
  display: flex;
  align-items: center !important;
}

.SubHeader-module__horizontally-centered___gXNlQ {
  display: flex;
  justify-content: center !important;
}

.SubHeader-module__horizontally-end___Jy2jd {
  display: flex;
  justify-content: end !important;
}

.SubHeader-module__vertically-start___jBKyW {
  display: flex;
  align-items: start !important;
}

.SubHeader-module__space-between___PNvr3 {
  display: flex;
  justify-content: space-between !important;
}

.SubHeader-module__flex-wrap___aQBm4 {
  flex-wrap: wrap !important;
}

.SubHeader-module__height-100___GI4cZ {
  height: 100%;
}

.SubHeader-module__width-50___DdWsX {
  width: 50% !important;
}

.SubHeader-module__width-100___G5OzU {
  width: 100%;
}

.SubHeader-module__cursor-pointer___n05HO {
  cursor: pointer;
}

.SubHeader-module__cursor-not-allowed___vs1f_ {
  cursor: not-allowed !important;
}

.SubHeader-module__absolute-centered___f1uev {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SubHeader-module__absolute___TIH3z {
  position: absolute;
}

.SubHeader-module__relative___sv2y6 {
  position: relative;
}

.SubHeader-module__fixed___UfI5Z {
  position: fixed;
}

.SubHeader-module__visible___YgpXc {
  opacity: 1;
}

.SubHeader-module__invisible___U1oAO {
  opacity: 0;
}

.SubHeader-module__col-90___hLV4D {
  width: 90% !important;
}

.SubHeader-module__col-auto___L_ThG {
  width: auto !important;
}

.SubHeader-module__medical-tabs___MS8A7 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SubHeader-module__medical-table-new___EtTzJ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SubHeader-module__medical-table-new___EtTzJ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SubHeader-module__medical-table-new___EtTzJ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SubHeader-module__medical-table-new___EtTzJ::-webkit-scrollbar-track {
  display: none;
}
.SubHeader-module__medical-table-new___EtTzJ.SubHeader-module__no-pagination___qmLeb {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SubHeader-module__medical-table-new___EtTzJ.SubHeader-module__no-pagination___qmLeb:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SubHeader-module__medical-table-new___EtTzJ.SubHeader-module__no-pagination___qmLeb::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SubHeader-module__medical-table-new___EtTzJ.SubHeader-module__no-pagination___qmLeb::-webkit-scrollbar-track {
  display: none;
}

.SubHeader-module__medical-table-empty___LsOj0 {
  padding: 14px 40px !important;
}

.SubHeader-module__icon-btn___dJlMj {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SubHeader-module__search-icon___wqYgM {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SubHeader-module__disable-select___KpGEa {
  user-select: none;
}

.SubHeader-module__break-word___RE8rv {
  word-break: break-word;
}

.SubHeader-module__popup-clear-btn___pmkYb {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SubHeader-module__scroll-m-b-20___KHFCC {
  scroll-margin-bottom: 20px;
}

.SubHeader-module__content___aQQQ6 {
  display: flex;
  padding: 30px 40px;
}
.SubHeader-module__content___aQQQ6 .SubHeader-module__button___rTB96 {
  height: 38px;
  width: 150px;
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/CGMOrdersFragment/components/SubHeader/SubHeader.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,kBAAA;AA8pBF;AA5pBE;EACE,YAAA;EACA,YAAA;EACA,iBAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.content {\n  display: flex;\n  padding: 30px 40px;\n\n  .button {\n    height: 38px;\n    width: 150px;\n    margin-left: auto;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SubHeader-module__font-s-10___CEYi2`,
	"fontS12": `SubHeader-module__font-s-12___zLveb`,
	"fontS13": `SubHeader-module__font-s-13___Y8tVo`,
	"fontS14": `SubHeader-module__font-s-14___Wt92S`,
	"fontS15": `SubHeader-module__font-s-15___JjG1T`,
	"fontS16": `SubHeader-module__font-s-16___fMVjU`,
	"fontS18": `SubHeader-module__font-s-18___OF1SU`,
	"fontS20": `SubHeader-module__font-s-20___alxvm`,
	"fontS22": `SubHeader-module__font-s-22___E3b2A`,
	"fontS28": `SubHeader-module__font-s-28___iam1e`,
	"fontW400": `SubHeader-module__font-w-400___MCCOw`,
	"fontW500": `SubHeader-module__font-w-500___eAib7`,
	"fontW600": `SubHeader-module__font-w-600___oN5FV`,
	"fontW700": `SubHeader-module__font-w-700___kMnsh`,
	"p5": `SubHeader-module__p-5___VIXOa`,
	"p12": `SubHeader-module__p-12___b_ghe`,
	"p16": `SubHeader-module__p-16___lfMLF`,
	"p30": `SubHeader-module__p-30___DOrAQ`,
	"pB0": `SubHeader-module__p-b-0___t7X1q`,
	"pB5": `SubHeader-module__p-b-5___y0aUa`,
	"pB10": `SubHeader-module__p-b-10___HAUBo`,
	"pB12": `SubHeader-module__p-b-12___z1a91`,
	"pB16": `SubHeader-module__p-b-16___K20OL`,
	"pB18": `SubHeader-module__p-b-18___cTzSk`,
	"pB20": `SubHeader-module__p-b-20____MzR3`,
	"pB25": `SubHeader-module__p-b-25____lMle`,
	"pB30": `SubHeader-module__p-b-30___QL_2i`,
	"pB50": `SubHeader-module__p-b-50___mY9D0`,
	"pT0": `SubHeader-module__p-t-0___sbXtY`,
	"pT12": `SubHeader-module__p-t-12___sZOgE`,
	"pT16": `SubHeader-module__p-t-16___cTs1O`,
	"pT18": `SubHeader-module__p-t-18___YiXVu`,
	"pT20": `SubHeader-module__p-t-20___nZL_f`,
	"pT30": `SubHeader-module__p-t-30___KjI34`,
	"pT40": `SubHeader-module__p-t-40___JZHv9`,
	"pT50": `SubHeader-module__p-t-50___LUj7I`,
	"pL20": `SubHeader-module__p-l-20____aRKv`,
	"pL30": `SubHeader-module__p-l-30___nnbK7`,
	"pL40": `SubHeader-module__p-l-40___btjXJ`,
	"pR16": `SubHeader-module__p-r-16___blGTr`,
	"pR20": `SubHeader-module__p-r-20___EI55r`,
	"pR30": `SubHeader-module__p-r-30___nlFVH`,
	"pR50": `SubHeader-module__p-r-50___VYTAU`,
	"pR60": `SubHeader-module__p-r-60___GsPJi`,
	"mB1": `SubHeader-module__m-b-1___SbmWw`,
	"mB2": `SubHeader-module__m-b-2___Lkwsr`,
	"mB6": `SubHeader-module__m-b-6___A4IwS`,
	"mB8": `SubHeader-module__m-b-8___qTEog`,
	"mB10": `SubHeader-module__m-b-10___fNT2h`,
	"mB14": `SubHeader-module__m-b-14___rQ7lU`,
	"mB16": `SubHeader-module__m-b-16___jyXFR`,
	"mB20": `SubHeader-module__m-b-20___SmZoR`,
	"mB22": `SubHeader-module__m-b-22____HLdV`,
	"mB24": `SubHeader-module__m-b-24___SbozO`,
	"mB30": `SubHeader-module__m-b-30___XsiGN`,
	"mB32": `SubHeader-module__m-b-32___ZDgeQ`,
	"mB40": `SubHeader-module__m-b-40___q7fkb`,
	"mT2": `SubHeader-module__m-t-2___cufqB`,
	"mT3": `SubHeader-module__m-t-3___Wm8jW`,
	"mT4": `SubHeader-module__m-t-4___aqdS6`,
	"mT5": `SubHeader-module__m-t-5___TTTN6`,
	"mT8": `SubHeader-module__m-t-8___nfRan`,
	"mT10": `SubHeader-module__m-t-10___Ali9_`,
	"mT15": `SubHeader-module__m-t-15___U98G6`,
	"mT16": `SubHeader-module__m-t-16___t3H9g`,
	"mT20": `SubHeader-module__m-t-20___zWRok`,
	"mT22": `SubHeader-module__m-t-22___mriH0`,
	"mT30": `SubHeader-module__m-t-30___A71eM`,
	"mT32": `SubHeader-module__m-t-32___ofbwf`,
	"mLAuto": `SubHeader-module__m-l-auto___tIwmo`,
	"mL4": `SubHeader-module__m-l-4___sj74t`,
	"mL5": `SubHeader-module__m-l-5___aDiDm`,
	"mL6": `SubHeader-module__m-l-6___C4DEB`,
	"mL8": `SubHeader-module__m-l-8___g3PVn`,
	"mL10": `SubHeader-module__m-l-10___kJtHW`,
	"mL16": `SubHeader-module__m-l-16___Rizi3`,
	"mL20": `SubHeader-module__m-l-20___wLSHn`,
	"mL24": `SubHeader-module__m-l-24___WvgLr`,
	"mL30": `SubHeader-module__m-l-30___vsEpl`,
	"mL35": `SubHeader-module__m-l-35___N3G9w`,
	"mL40": `SubHeader-module__m-l-40___GU7bs`,
	"mR8": `SubHeader-module__m-r-8___xwzoS`,
	"mR10": `SubHeader-module__m-r-10___Qq4l4`,
	"mR16": `SubHeader-module__m-r-16___BTZw8`,
	"mR20": `SubHeader-module__m-r-20___uDdb3`,
	"mR24": `SubHeader-module__m-r-24___JEEaV`,
	"mR30": `SubHeader-module__m-r-30___uKGZW`,
	"mR40": `SubHeader-module__m-r-40___ntpJp`,
	"borderR3": `SubHeader-module__border-r-3___ldPMu`,
	"borderR4": `SubHeader-module__border-r-4___onLbR`,
	"borderR6": `SubHeader-module__border-r-6___RpHT_`,
	"borderR10": `SubHeader-module__border-r-10___dQs0Y`,
	"borderR12": `SubHeader-module__border-r-12___yMbAk`,
	"borderR16": `SubHeader-module__border-r-16___XjMQy`,
	"borderR50": `SubHeader-module__border-r-50___EWE3B`,
	"primaryBorder": `SubHeader-module__primary-border___lDvMx`,
	"primaryBorderB": `SubHeader-module__primary-border-b___IBVYP`,
	"primaryBorderT": `SubHeader-module__primary-border-t___wYKFz`,
	"primaryBorderL": `SubHeader-module__primary-border-l___YXGX5`,
	"primaryBorderR": `SubHeader-module__primary-border-r___D9ygY`,
	"secondaryBorder": `SubHeader-module__secondary-border___lsmz_`,
	"secondaryBorderB": `SubHeader-module__secondary-border-b___dk_aA`,
	"secondaryBorderT": `SubHeader-module__secondary-border-t___h2nBd`,
	"secondaryBorderL": `SubHeader-module__secondary-border-l___MhRKK`,
	"secondaryBorderR": `SubHeader-module__secondary-border-r___SLnT6`,
	"gap0": `SubHeader-module__gap-0___e6lgI`,
	"gap2": `SubHeader-module__gap-2___sM1MJ`,
	"gap4": `SubHeader-module__gap-4___WdgAH`,
	"gap5": `SubHeader-module__gap-5___LXXrs`,
	"gap6": `SubHeader-module__gap-6___ZbyGy`,
	"gap8": `SubHeader-module__gap-8___YGBqI`,
	"gap10": `SubHeader-module__gap-10___yAipQ`,
	"gap12": `SubHeader-module__gap-12___CcUia`,
	"gap14": `SubHeader-module__gap-14___CF1Ht`,
	"gap16": `SubHeader-module__gap-16___Zsp6l`,
	"gap18": `SubHeader-module__gap-18___Y47xj`,
	"gap20": `SubHeader-module__gap-20___ThRla`,
	"gap24": `SubHeader-module__gap-24___ebsL7`,
	"gap26": `SubHeader-module__gap-26___RPEU9`,
	"gap30": `SubHeader-module__gap-30___yuBkD`,
	"gap32": `SubHeader-module__gap-32___XjqzX`,
	"gap40": `SubHeader-module__gap-40____Bqho`,
	"gap50": `SubHeader-module__gap-50___L_dYk`,
	"flex1": `SubHeader-module__flex-1___tJtRt`,
	"flexNone": `SubHeader-module__flex-none___BRtXn`,
	"flexColumn": `SubHeader-module__flex-column___KS9VY`,
	"flexRow": `SubHeader-module__flex-row___A9p7Y`,
	"verticallyCentered": `SubHeader-module__vertically-centered___zrvwW`,
	"horizontallyCentered": `SubHeader-module__horizontally-centered___gXNlQ`,
	"horizontallyEnd": `SubHeader-module__horizontally-end___Jy2jd`,
	"verticallyStart": `SubHeader-module__vertically-start___jBKyW`,
	"spaceBetween": `SubHeader-module__space-between___PNvr3`,
	"flexWrap": `SubHeader-module__flex-wrap___aQBm4`,
	"height100": `SubHeader-module__height-100___GI4cZ`,
	"width50": `SubHeader-module__width-50___DdWsX`,
	"width100": `SubHeader-module__width-100___G5OzU`,
	"cursorPointer": `SubHeader-module__cursor-pointer___n05HO`,
	"cursorNotAllowed": `SubHeader-module__cursor-not-allowed___vs1f_`,
	"absoluteCentered": `SubHeader-module__absolute-centered___f1uev`,
	"absolute": `SubHeader-module__absolute___TIH3z`,
	"relative": `SubHeader-module__relative___sv2y6`,
	"fixed": `SubHeader-module__fixed___UfI5Z`,
	"visible": `SubHeader-module__visible___YgpXc`,
	"invisible": `SubHeader-module__invisible___U1oAO`,
	"col90": `SubHeader-module__col-90___hLV4D`,
	"colAuto": `SubHeader-module__col-auto___L_ThG`,
	"medicalTabs": `SubHeader-module__medical-tabs___MS8A7`,
	"medicalTableNew": `SubHeader-module__medical-table-new___EtTzJ`,
	"noPagination": `SubHeader-module__no-pagination___qmLeb`,
	"medicalTableEmpty": `SubHeader-module__medical-table-empty___LsOj0`,
	"iconBtn": `SubHeader-module__icon-btn___dJlMj`,
	"searchIcon": `SubHeader-module__search-icon___wqYgM`,
	"disableSelect": `SubHeader-module__disable-select___KpGEa`,
	"breakWord": `SubHeader-module__break-word___RE8rv`,
	"popupClearBtn": `SubHeader-module__popup-clear-btn___pmkYb`,
	"scrollMB20": `SubHeader-module__scroll-m-b-20___KHFCC`,
	"content": `SubHeader-module__content___aQQQ6`,
	"button": `SubHeader-module__button___rTB96`
};
module.exports = ___CSS_LOADER_EXPORT___;
